export enum AddressType {
  Pickup,
  Delivery,
}
